import {
  OFFER_SOURCE_OF_FUNDS_INDIA,
  SELECTED_FINANCIAL_INSTITUTION,
} from 'constants/fields';
import {
  STEP_CARD_SURCHARGE,
  STEP_PAY,
  STEP_RECURRING_CARD_PAYMENT,
  STEP_RECURRING_DIRECT_DEBIT_PAYMENT,
  STEP_SOURCE_OF_FUNDS,
} from 'constants/paymentSteps';
import type { RootState } from 'reducers/types';
import { getHiddenFieldIds } from 'selectors/entities/fields/fields';
import { apiReadOnlyFields, getPaymentStepsForWizard } from '../ui';

export const getNonPrefillableFieldsForIndia = (state: RootState) => {
  const hiddenFields = getHiddenFieldIds(state);

  const nonPrefillableFields = [...hiddenFields, OFFER_SOURCE_OF_FUNDS_INDIA];

  return apiReadOnlyFields(state).concat(nonPrefillableFields);
};

export const sourceOfFundsIndia = (state: RootState) => {
  const {
    ui: {
      fieldValues: { [OFFER_SOURCE_OF_FUNDS_INDIA]: offerSourceOfFunds } = {},
    } = {},
  } = state;
  return offerSourceOfFunds;
};

export const financialInstitutionIndia = (state: RootState) => {
  const {
    ui: {
      fieldValues: {
        [SELECTED_FINANCIAL_INSTITUTION]: financialInstitution,
      } = {},
    } = {},
  } = state;
  return financialInstitution;
};

export const getPaymentStepsForIndiaWizard = (state: RootState) => {
  const steps = getPaymentStepsForWizard(state);
  return [STEP_SOURCE_OF_FUNDS, ...steps];
};

export const getPaymentStepsForIndia = (state: RootState) => {
  const steps = getPaymentStepsForIndiaWizard(state);

  if (
    steps.includes(STEP_CARD_SURCHARGE) ||
    steps.includes(STEP_RECURRING_CARD_PAYMENT) ||
    steps.includes(STEP_RECURRING_DIRECT_DEBIT_PAYMENT)
  ) {
    return [
      ...steps.filter(
        step =>
          step !== STEP_CARD_SURCHARGE &&
          step !== STEP_RECURRING_CARD_PAYMENT &&
          step !== STEP_RECURRING_DIRECT_DEBIT_PAYMENT,
      ),
      STEP_PAY,
    ];
  }

  return steps;
};
